"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const base64_js_1 = __importDefault(require("base64-js"));
const tweetnacl_1 = __importDefault(require("tweetnacl"));
exports.generateDeeplink = (context, contextId, nodeUrl) => {
    const endpoint = nodeUrl ? nodeUrl : `http:%2f%2fnode.brightid.org`;
    return `brightid://link-verification/${endpoint}/${context}/${contextId}`;
};
exports.verifyContextId = (context, contextId, nodeUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = nodeUrl
        ? nodeUrl + "/node/v5/verifications"
        : "https://app.brightid.org/node/v5/verifications";
    try {
        const res = yield axios_1.default.get(`${endpoint}/${context}/${contextId}`);
        console.log(res.data);
        return res.data.data;
    }
    catch (err) {
        console.log(err.response);
        return {
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data,
        };
    }
});
exports.sponsor = (key, context, contextId, nodeUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = nodeUrl
        ? nodeUrl + `/node/v5/operations`
        : "https://app.brightid.org/node/v5/operations";
    let sponsorships = yield exports.availableSponsorships(context, nodeUrl);
    if (typeof sponsorships === "number" && sponsorships < 1) {
        return { status: "error", statusReason: "no available sponsorships" };
    }
    if (typeof sponsorships !== "number")
        return sponsorships;
    const op = {
        name: "Sponsor",
        app: context,
        contextId: contextId,
        timestamp: Date.now(),
        v: 5,
        sig: "",
    };
    const message = getMessage(op);
    const arrayedMessage = Buffer.from(message);
    const keyBuffer = base64_js_1.default.toByteArray(key);
    let signature = tweetnacl_1.default.sign.detached(arrayedMessage, keyBuffer);
    op.sig = base64_js_1.default.fromByteArray(signature);
    console.log(op);
    try {
        let res = yield axios_1.default.post(endpoint, op);
        console.log(res);
        return { status: "success", statusReason: res.data.data.hash };
    }
    catch (err) {
        console.log(err.response);
        return {
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data,
        };
    }
});
const getMessage = (op) => {
    const signedOp = {};
    for (let k in op) {
        if (["sig", "sig1", "sig2", "hash"].includes(k)) {
            continue;
        }
        signedOp[k] = op[k];
    }
    return fast_json_stable_stringify_1.default(signedOp);
};
exports.availableSponsorships = (context, nodeUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = nodeUrl
        ? nodeUrl + `/node/v5/testblocks`
        : "https://app.brightid.org/node/v5/apps";
    try {
        let res = yield axios_1.default.get(`${endpoint}/${context}`);
        console.log(res);
        return res.data.data.unusedSponsorships;
    }
    catch (err) {
        console.log(err.response);
        return {
            status: err.response.status,
            statusText: err.response.statusText,
            data: err.response.data,
        };
    }
});
